export default "__VITE_ASSET__CWHZ9xTs__"